export const
GET_COMPONENTS_REQUEST = 'GET_COMPONENTS_REQUEST',
GET_COMPONENTS_SUCCESS = 'GET_COMPONENTS_SUCCESS',
GET_COMPONENTS_FAILURE = 'GET_COMPONENTS_FAILURE';


// WEBPACK FOOTER //
// ./src/types/Components.js